
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curriculum/bluebonnet-thank-you",
      function () {
        return require("private-next-pages/curriculum/bluebonnet-thank-you.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curriculum/bluebonnet-thank-you"])
      });
    }
  